import type {
	Course,
	CourseMindItemSearchResult,
	MindItem,
} from '@kimuno/api-sdk/lib/types/responses/MindItem';

import { getCommonCardProps } from '../../../Search/SearchResults/SearchResults';
import type { CourseMuiCardProps } from './CourseMuiCard';

export const courseTypeToPresentationNameMap: Record<Course['type'], string> = {
	Impuls: 'Impuls',
	Kurs: 'Kurs',
	Webinar: 'Webinar-Aufzeichung',
};
export const joinAuthorNames = (authors?: Course['authors']) =>
	authors ? authors.map(({ name }) => name).join(' | ') : '';

export const getCourseMuiCardProps = (
	item: CourseMindItemSearchResult | MindItem<'course'>
): CourseMuiCardProps => {
	return {
		contentType: 'course',
		course: item.course,
		...getCommonCardProps({ ...item, type: 'mindItem' }),
	};
};
